import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, TransferFundDialogueHandler } from '../types';
import TransferFundDialogueContext from './TransferFundContext';

const { ConfirmationDialogue } = vp;

type TransferFundDialogueProps = {
  handleDialogue: DialogueHandler<TransferFundDialogueHandler>;
};

type FC = FunctionComponent<TransferFundDialogueProps>;

const TransferFundDialogue: FC = ({ handleDialogue }: TransferFundDialogueProps) => {
  const { showTransferFundErrorAlert, transferFundError, showTransferFundConfirmAlert } =
    useContext(TransferFundDialogueContext);

  return useMemo(
    () => (
      <div>
        {/* Fund Transfer Error */}
        <ConfirmationDialogue
          isVisible={showTransferFundErrorAlert}
          title="Error! The transfer was not completed."
          status="error"
          subTitle={`${transferFundError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
        {/* Transfer fund Confirm */}
        <ConfirmationDialogue
          isVisible={showTransferFundConfirmAlert ? showTransferFundConfirmAlert : false}
          title="Submit Transfer?"
          status="alert"
          subTitle="Once transfer is submitted, your transaction will begin processing. Please ensure all details are accurate before submission."
          confirm={{
            label: 'Submit Transfer',
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: 'Go Back',
            action: () => handleDialogue({ type: 'confirm', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showTransferFundErrorAlert, transferFundError, showTransferFundConfirmAlert],
  );
};

export default TransferFundDialogue;
